export const Logo = ({className}) => {
    return (
        <div className={`${className} text-center font-bold text-gray-500`}><span className={'text-primary-red'}>DAKWAH</span><span className={'text-primary-blue'}>FKAM</span></div>
    )
}